import * as React from 'react';
import { UserState } from 'app/reducers/state';
import { Callout, Intent, H4, Button, Dialog } from '@blueprintjs/core';
import ReactTable from 'react-table';
import * as superagent from 'superagent';

interface Props {
    user: UserState;
};

interface State {
    data: any;
    isOpen: any;
}

export class ResourcesView extends React.Component<Props, State> {

    state: State = {
        data: [],
        isOpen: {}
    }

    getColumns() {
        return [{
            Header: "Video",
            accessor: 'title',
            Cell: (props) => {
                return <strong>{props.value}</strong>
            },
            width: 250
        }, {
            Header: "",
            accessor: 'link',
            Cell: (props) => {
                if (props.value === "") {
                    return <span></span>
                }
                return <div>
                    <Dialog style={{width: '70vw'}} isOpen={this.state.isOpen[props.value]} onClose={() => {
                        this.setState({ isOpen: { ...this.state.isOpen, [props.value]: false } })
                    }}>
                        <div style={{ width: '70vw', display: 'block', margin: 'auto' }}>
                            <video width="100%" controls>
                                <source src={props.value} type="video/mp4" />
                                Your browser does not support the video tag.
                            </video>
                        </div>
                    </Dialog>
                    <Button icon="play" text="Play Video" onClick={() => {
                        this.setState({ isOpen: { ...this.state.isOpen, [props.value]: true } })
                    }} />
                </div>
            }
        }]
    }

    componentDidMount(): void {
        superagent.
            get("assets/educator_resources.json").
            end((error: any, response: any) => {

                //@ts-ignore
                if (this.props.user.classicMode === 2 || this.props.user.classicMode === '2') {
                    this.setState({ data: response.body.classic });
                }
                else {
                    this.setState({ data: response.body.lab });
                }
            });
    }

    getData() {
        let labMode = true;

        //@ts-ignore
        if (this.props.user.classicMode === 2 || this.props.user.classicMode === '2') {
            labMode = false;
        }

        return this.state.data;

        if (labMode) {
            return [{
                title: "Leadership Styles",
                link: ""
            }, {
                title: "Directive",
                link: "https://vleader-supportvideo-resources-production.s3.us-east-1.amazonaws.com/35774091.mp4"
            }, {
                title: "Delegative",
                link: "https://vleader-supportvideo-resources-production.s3.us-east-1.amazonaws.com/46309951.mp4"
            }, {
                title: "Participative",
                link: "https://vleader-supportvideo-resources-production.s3.us-east-1.amazonaws.com/57812349.mp4"
            }, {
                title: "Transformational",
                link: "https://vleader-supportvideo-resources-production.s3.us-east-1.amazonaws.com/47956689.mp4"
            }, {
                title: "Opportunities in Conflict",
                link: ""
            }, {
                title: "Competitive",
                link: "https://vleader-supportvideo-resources-production.s3.us-east-1.amazonaws.com/48429370.mp4"
            }, {
                title: "Accommodating",
                link: "https://vleader-supportvideo-resources-production.s3.us-east-1.amazonaws.com/87695058.mp4"
            }, {
                title: "Compromising",
                link: "https://vleader-supportvideo-resources-production.s3.us-east-1.amazonaws.com/45264785.mp4"
            }, {
                title: "Collaborative",
                link: "https://vleader-supportvideo-resources-production.s3.us-east-1.amazonaws.com/51614001.mp4"
            }, {
                title: "Facilitating Change",
                link: ""
            }, {
                title: "Forming",
                link: "https://us-east-1.console.aws.amazon.com/s3/object/vleader-supportvideo-resources-production?region=us-east-1&bucketType=general&prefix=12707529.mp4"
            }, {
                title: "Storming",
                link: "https://vleader-supportvideo-resources-production.s3.us-east-1.amazonaws.com/75402834.mp4"
            }, {
                title: "Norming",
                link: "https://vleader-supportvideo-resources-production.s3.us-east-1.amazonaws.com/97963016.mp4"
            }, {
                title: "Facilitating (Performing)",
                link: "https://vleader-supportvideo-resources-production.s3.us-east-1.amazonaws.com/28252677.mp4"
            }]
        }
        else {
            return [{
                title: "CLASSIC Transforming Relationships",
                link: "https://vleader-supportvideo-resources-production.s3.us-east-1.amazonaws.com/Classic/Scenario_One_Classic.mp4"
            }, {
                title: "Opportunities in Conflict",
                link: "https://vleader-supportvideo-resources-production.s3.us-east-1.amazonaws.com/Classic/Opportunities+in+Conflict.mp4"
            }, {
                title: "Group Dynamics",
                link: "https://vleader-supportvideo-resources-production.s3.us-east-1.amazonaws.com/Classic/Scenario_One_Classic.mp4"
            }, {
                title: "Crisis Management",
                link: "https://vleader-supportvideo-resources-production.s3.us-east-1.amazonaws.com/Classic/Scenario_One_Classic.mp4"
            }]
        }
    }

    render() {
        return <span style={{ display: 'block', width: '50%', minWidth: '700px', margin: 'auto' }}>
            <Callout intent={Intent.NONE}>
                <H4>Educator Resources</H4>

                <ReactTable style={{ marginTop: '20px' }} columns={this.getColumns()} data={this.getData()} pageSize={this.getData().length} showPagination={false} showPageSizeOptions={false} />
            </Callout>
        </span>
    }
}
